;
export const localeMessage = {
  en: {
    thirdPartyWarehouseStocktakingList: `3rd Party Warehouse Pull Stock`,
    stocktakingNumber: `Single Number`,
    stocktakingStatus: `Pull Status`,
    waitingStocktaking: `Waiting Stocktaking`,
    pullSucceed: `Pull Succeed`,
    pullFailed: `Pull Failed`,
    partialStocktakingSucceed: `Partial Stocktaking Succeed`,
    stocktakingSucceed: `Stocktaking Succeed`,
    stocktakingFailed: `Stocktaking Failed`,
    sKUQuantity: `Total number of MSKUs pulled`,
    excessStockSKU: `MSKU stock increase`,
    stockExcess: `Stock Excess`,
    stockLess: `Stock Less`,
    lessStockSKU: `MSKU stock decrease`,
    stockExcessAmount: `Increase ammount`,
    stockLessAmount: `Decrease amount`,
    stocktakingAmount: `Difference amount`,
    stocktakingQuantity: `Stock difference`,
    thirdPartyStock: `Third Party Stock`,
    pullFailureReason: `Pull failure reason`,
    createTime: `Create Time`,
    updateTime: `Update Time`,
    operationType: `Operation Type`,
    operator: `Operator`,
    stockBeforeStocktaking: `Stock before pulling`,
    stockAfterStocktaking: `Stock after pull`,
    masterSku: `Master SKU`,
    productName: `Product Name`,
    search: `Search`,
    pleaseEnter: `Please Enter`,
    productInformation: `Product Information`,
    warehouse: `Warehouse`,
    fulfillmentServiceProvider: `Fulfillment Service Provider`,
    reset: `Reset`,
    allstocktakingissuccessful: `All stocktaking is successful`,
    partialstocktaking: `Partial stocktaking`,
    allstocktakingfailed: `All stocktaking failed`,
    somefailed: `Some failed`,
    somevoid: `Some void`,
    someexecute: `Some execute`,
    executed: `Executed`,
    faileds: `Failed`,
    Voided: `Voided`,
    manualsynchronization: `Manual synchronization`,
    inventorycalibrationexistsasataskinprogress: `Inventory calibration exists as a task in progress`,
    systemregularsynchronization: `System regular synchronization`,
    create: `Create`,
    stockmatch: `Stock Match`,
    StocktakingDetail: `Stocktaking detail`
  },
  zh: {
    thirdPartyWarehouseStocktakingList: `\u4E09\u65B9\u4ED3\u5E93\u5B58\u62C9\u53D6`,
    stocktakingNumber: `\u5355\u53F7`,
    stocktakingStatus: `\u62C9\u53D6\u72B6\u6001`,
    waitingStocktaking: `\u5F85\u76D8\u70B9`,
    pullSucceed: `\u62C9\u53D6\u6210\u529F`,
    pullFailed: `\u62C9\u53D6\u5931\u8D25`,
    partialStocktakingSucceed: `\u90E8\u5206\u76D8\u70B9\u6210\u529F`,
    stocktakingSucceed: `\u76D8\u70B9\u6210\u529F`,
    stocktakingFailed: `\u76D8\u70B9\u5931\u8D25`,
    sKUQuantity: `\u62C9\u53D6MSKU\u603B\u6570`,
    excessStockSKU: `\u5E93\u5B58\u589E\u52A0MSKU`,
    stockExcess: `\u76D8\u76C8`,
    stockLess: `\u76D8\u4E8F`,
    lessStockSKU: `\u5E93\u5B58\u51CF\u5C11MSKU`,
    stockExcessAmount: `\u589E\u52A0\u91D1\u989D`,
    stockLessAmount: `\u51CF\u5C11\u91D1\u989D`,
    stocktakingAmount: `\u5DEE\u5F02\u91D1\u989D`,
    stocktakingQuantity: `\u5E93\u5B58\u5DEE\u5F02`,
    thirdPartyStock: `\u4E09\u65B9\u4ED3\u5E93\u5B58`,
    pullFailureReason: `\u62C9\u53D6\u5931\u8D25\u539F\u56E0`,
    createTime: `\u521B\u5EFA\u65F6\u95F4`,
    updateTime: `\u66F4\u65B0\u65F6\u95F4`,
    operationType: `\u64CD\u4F5C\u7C7B\u578B`,
    operator: `\u64CD\u4F5C\u4EBA`,
    stockBeforeStocktaking: `\u62C9\u53D6\u524D\u5E93\u5B58`,
    stockAfterStocktaking: `\u62C9\u53D6\u540E\u5E93\u5B58`,
    masterSku: `\u4E3BSKU`,
    productName: `\u5546\u54C1\u540D\u79F0`,
    search: `\u641C\u7D22`,
    pleaseEnter: `\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9`,
    productInformation: `\u5546\u54C1\u8BE6\u60C5`,
    warehouse: `\u4ED3\u5E93`,
    fulfillmentServiceProvider: `\u5C65\u7EA6\u670D\u52A1\u5546`,
    reset: `\u6E05\u7A7A`,
    allstocktakingissuccessful: `\u76D8\u70B9\u6210\u529F`,
    partialstocktaking: `\u90E8\u5206\u76D8\u70B9`,
    allstocktakingfailed: `\u76D8\u70B9\u5931\u8D25`,
    somefailed: `\u90E8\u5206\u5931\u8D25`,
    somevoid: `\u90E8\u5206\u4F5C\u5E9F`,
    someexecute: `\u90E8\u5206\u6267\u884C`,
    executed: `\u5DF2\u6267\u884C`,
    faileds: `\u5DF2\u5931\u8D25`,
    Voided: `\u5DF2\u4F5C\u5E9F`,
    manualsynchronization: `\u4EBA\u5DE5\u540C\u6B65`,
    inventorycalibrationexistsasataskinprogress: `\u5E93\u5B58\u6821\u51C6\u5B58\u5728\u6267\u884C\u4E2D\u7684\u4EFB\u52A1`,
    systemregularsynchronization: `\u7CFB\u7EDF\u5B9A\u65F6\u540C\u6B65`,
    create: `\u5DF2\u521B\u5EFA`,
    stockmatch: `\u76D8\u5E73`,
    StocktakingDetail: `\u76D8\u70B9\u5355\u8BE6\u60C5`
  },
  id: {
    thirdPartyWarehouseStocktakingList: `Penarikan Stok Gudang Pihak Ketiga`,
    stocktakingNumber: `Nomor Tunggal`,
    stocktakingStatus: `Status Penarikan`,
    waitingStocktaking: `Menunggu Stock Opname`,
    pullSucceed: `Penarikan Berhasil`,
    pullFailed: `Penarikan Gagal`,
    partialStocktakingSucceed: `Parsial Stock Opname Berhasil`,
    stocktakingSucceed: `Stock Opname Berhasil`,
    stocktakingFailed: `Stock Opname Gagal`,
    sKUQuantity: `Jumlah total MSKU ditarik`,
    excessStockSKU: `Stok MSKU bertambah`,
    stockExcess: `Stok Lebih`,
    stockLess: `Stok Kurang`,
    lessStockSKU: `Stok MSKU berkurang`,
    stockExcessAmount: `Jumlah pertambahan`,
    stockLessAmount: `Jumlah kekurangan`,
    stocktakingAmount: `Perbedaan jumlah`,
    stocktakingQuantity: `Perbedaan stok`,
    thirdPartyStock: `Stok Gudang Pihak Ketiga`,
    pullFailureReason: `Alasan Penarikan Gagal`,
    createTime: `Waktu Pembuatan`,
    updateTime: `Waktu Pembaruan`,
    operationType: `Tipe Operasi`,
    operator: `Operator`,
    stockBeforeStocktaking: `Stok sebelum ditarik`,
    stockAfterStocktaking: `Stok setelah tarik`,
    masterSku: `Master SKU`,
    productName: `Nama Produk`,
    search: `Cari`,
    pleaseEnter: `Masukkan`,
    productInformation: `Informasi produk`,
    warehouse: `Gudang`,
    fulfillmentServiceProvider: `Penyedia Layanan Fulfillment`,
    reset: `Reset`,
    allstocktakingissuccessful: `Semua stock opname berhasil`,
    partialstocktaking: `Parsial stock opname`,
    allstocktakingfailed: `Semua stock opname gagal`,
    somefailed: `Sebagian gagal`,
    somevoid: `Sebagian batal`,
    someexecute: `Sebagian terlaksana`,
    executed: `Telah terlaksana`,
    faileds: `Telah gagal`,
    Voided: `Telah batal`,
    manualsynchronization: `sinkronisasi manual`,
    inventorycalibrationexistsasataskinprogress: `Kalibrasi stok termasuk tugas yang sedang dijalankan`,
    systemregularsynchronization: `Sinkronisasi sistem reguler`,
    create: `Buat`,
    stockmatch: `Stok Sesuai`,
    StocktakingDetail: `Detail stock opname`
  },
  th: {
    thirdPartyWarehouseStocktakingList: `\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48 3 \u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    stocktakingNumber: `\u0E40\u0E25\u0E02\u0E40\u0E14\u0E35\u0E48\u0E22\u0E27`,
    stocktakingStatus: `\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E14\u0E36\u0E07`,
    waitingStocktaking: `\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    pullSucceed: `\u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    pullFailed: `\u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    partialStocktakingSucceed: `\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    stocktakingSucceed: `\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    stocktakingFailed: `\u0E15\u0E23\u0E27\u0E08\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    sKUQuantity: `\u0E08\u0E33\u0E19\u0E27\u0E19 MSKU \u0E17\u0E35\u0E48\u0E14\u0E36\u0E07\u0E2D\u0E2D\u0E01\u0E21\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    excessStockSKU: `\u0E2A\u0E15\u0E47\u0E2D\u0E01 MSKU \u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E36\u0E49\u0E19`,
    stockExcess: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E01\u0E34\u0E19`,
    stockLess: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22`,
    lessStockSKU: `\u0E2A\u0E15\u0E47\u0E2D\u0E01 MSKU \u0E25\u0E14\u0E25\u0E07`,
    stockExcessAmount: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19`,
    stockLessAmount: `\u0E25\u0E14\u0E08\u0E33\u0E19\u0E27\u0E19`,
    stocktakingAmount: `\u0E04\u0E27\u0E32\u0E21\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E08\u0E33\u0E19\u0E27\u0E19`,
    stocktakingQuantity: `\u0E04\u0E27\u0E32\u0E21\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    thirdPartyStock: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E25\u0E31\u0E07\u0E1D\u0E32\u0E01\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    pullFailureReason: `\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    createTime: `\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    updateTime: `\u0E40\u0E27\u0E25\u0E32\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15`,
    operationType: `\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    operator: `\u0E1C\u0E39\u0E49\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    stockBeforeStocktaking: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E01\u0E48\u0E2D\u0E19\u0E14\u0E36\u0E07`,
    stockAfterStocktaking: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07`,
    masterSku: `SKU \u0E2B\u0E25\u0E31\u0E01`,
    productName: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    search: `\u0E04\u0E49\u0E19\u0E2B\u0E32`,
    pleaseEnter: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32`,
    productInformation: `\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    warehouse: `\u0E04\u0E25\u0E31\u0E07`,
    fulfillmentServiceProvider: `\u0E1C\u0E39\u0E49\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23Fulfillment`,
    reset: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E43\u0E2B\u0E21\u0E48`,
    allstocktakingissuccessful: `\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22`,
    partialstocktaking: `\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19`,
    allstocktakingfailed: `\u0E01\u0E32\u0E23\u0E19\u0E31\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    somefailed: `\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    somevoid: `\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19`,
    someexecute: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19`,
    executed: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27`,
    faileds: `\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    Voided: `\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30`,
    manualsynchronization: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07`,
    inventorycalibrationexistsasataskinprogress: `\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E39\u0E48`,
    systemregularsynchronization: `\u0E15\u0E31\u0E49\u0E07\u0E40\u0E27\u0E25\u0E32\u0E25\u0E48\u0E27\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    create: `\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    stockmatch: `\u0E08\u0E31\u0E1A\u0E04\u0E39\u0E48\u0E2A\u0E15\u0E47\u0E2D\u0E01`,
    StocktakingDetail: `\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E25\u0E31\u0E07`
  },
  vn: {
    thirdPartyWarehouseStocktakingList: `K\xE9o t\u1ED3n t\u1EEB kho b\xEAn th\u1EE9 ba`,
    stocktakingNumber: `M\xE3 \u0111\u01A1n`,
    stocktakingStatus: `T\xECnh tr\u1EA1ng k\xE9o`,
    waitingStocktaking: `Ch\u1EDD ki\u1EC3m k\xEA`,
    pullSucceed: `K\xE9o thanh c\xF4ng`,
    pullFailed: `K\xE9o th\u1EA5t b\u1EA1i`,
    partialStocktakingSucceed: `Ki\u1EC3m k\xEA th\xE0nh c\xF4ng m\u1ED9t ph\u1EA7n`,
    stocktakingSucceed: `Ki\u1EC3m k\xEA th\xE0nh c\xF4ng`,
    stocktakingFailed: `Ki\xEAm k\xEA th\u1EA5t b\u1EA1i`,
    sKUQuantity: `T\u1ED5ng s\u1ED1 MSKU \u0111\u01B0\u1EE3c k\xE9o`,
    excessStockSKU: `T\u0103ng t\u1ED3n kho MSKU`,
    stockExcess: `Th\u1EB7ng d\u01B0`,
    stockLess: `Thi\u1EBFu h\u1EE5t`,
    lessStockSKU: `Gi\u1EA3m t\u1ED3n kho MSKU`,
    stockExcessAmount: `T\u0103ng s\u1ED1 ti\u1EC1n`,
    stockLessAmount: `Gi\u1EA3m s\u1ED1 ti\u1EC1n`,
    stocktakingAmount: `S\u1ED1 ti\u1EC1n ch\xEAnh l\u1EC7ch`,
    stocktakingQuantity: `T\u1ED3n kho ch\xEAnh l\u1EC7ch`,
    thirdPartyStock: `T\u1ED3n kho b\xEAn th\u1EE9 ba`,
    pullFailureReason: `Nguy\xEAn nh\xE2n k\xE9o th\u1EA5t b\u1EA1i`,
    createTime: `Th\u1EDDi gian t\u1EA1o`,
    updateTime: `Th\u1EDDi gian c\u1EADp nh\u1EADt`,
    operationType: `Lo\u1EA1i thao t\xE1c`,
    operator: `Ng\u01B0\u1EDDi th\u1EF1c hi\u1EC7n`,
    stockBeforeStocktaking: `K\xE9o t\u1ED3n kho tr\u01B0\u1EDBc`,
    stockAfterStocktaking: `K\xE9o t\u1ED3n kho sau`,
    masterSku: `SKU ch\xEDnh`,
    productName: `T\xEAn s\u1EA3n ph\u1EA9m`,
    search: `T\xECm ki\u1EBFm`,
    pleaseEnter: `Vui l\xF2ng nh\u1EADp n\u1ED9i dung t\xECm ki\u1EBFm`,
    productInformation: `Th\xF4ng tin s\u1EA3n ph\u1EA9m`,
    warehouse: `Kho h\xE0ng`,
    fulfillmentServiceProvider: `Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 Fulfillment`,
    reset: `\u0110\u1EB7t l\u1EA1i`,
    allstocktakingissuccessful: `Ki\u1EC3m k\xEA t\u1EA5t c\u1EA3 th\xE0nh c\xF4ng`,
    partialstocktaking: `Ki\u1EC3m k\xEA m\u1ED9t ph\u1EA7n`,
    allstocktakingfailed: `Ki\u1EC3m k\xEA t\u1EA5t c\u1EA3 th\u1EA5t b\u1EA1i`,
    somefailed: `M\u1ED9t ph\u1EA7n th\u1EA5t b\u1EA1i`,
    somevoid: `M\u1ED9t ph\u1EA7n v\xF4 hi\u1EC7u`,
    someexecute: `M\u1ED9t ph\u1EA7n \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n`,
    executed: `\u0110\xE3 ho\xE0n th\xE0nh`,
    faileds: `Th\u1EA5t b\u1EA1i`,
    Voided: `V\xF4 hi\u1EC7u`,
    manualsynchronization: `\u0110\u1ED3ng b\u1ED9 th\u1EE7 c\xF4ng`,
    inventorycalibrationexistsasataskinprogress: `Hi\u1EC7u chu\u1EA9n kho h\xE0ng \u0111ang \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n t\u1EA5t y\u1EBFu trong quy tr\xECnh`,
    systemregularsynchronization: `\u0110\u1ED3ng b\u1ED9 h\xF3a th\u1EDDi gian h\u1EC7 th\u1ED1ng`,
    create: `T\u1EA1o`,
    stockmatch: `\u0110\u1ED1i chi\u1EBFu h\xE0ng h\xF3a`,
    StocktakingDetail: `Chi ti\u1EBFt ki\u1EC3m k\xEA`
  }
};
